<div class="p-md-4">
  <app-company-list [favoriteMode]="true"></app-company-list>
</div>